import { GET_CLIENT_CUSTOMER, GET_CLIENT_CUSTOMER_SUCCESS, GET_CLIENT_CUSTOMER_ERROR, GET_CLIENT_CUSTOMER_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetClientCustomers = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_CUSTOMER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_CUSTOMER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_CLIENT_CUSTOMER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_CUSTOMER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetClientCustomers;
